import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Website of BChip - all support questions: support@bchip.eu - privacy statement: https://bchip.eu/privacyverklaring.pdf
        </p>
      </header>
    </div>
  );
}

export default App;
